import React,{useState} from "react";
import { InfoCircleOutlined } from '@ant-design/icons';
import { Button, Col, Collapse, Divider, Row, Spin, Space, Typography} from "antd";
import { useNavigate } from "react-router-dom";
import { SubPageLayout } from '../applicant/shared/components/sub-page-layout';
import { LandingPageHeader } from "../applicant/shared/components/landing-page-header";
import { useMaintenanceMessage } from '../../shared/maintenance-message';


export const LoginPage: React.FC<any> = () => {
    const { Title, Paragraph, Link } = Typography;
    const { Panel } = Collapse;
    const { isImpending, isMaintenance } = useMaintenanceMessage();
   
    const navigate = useNavigate();
    const handleLogin = () => {
      navigate("/auth-redirect");
    };
    const [isProcessing] = useState(false);
  
    const loginLayout = (
      <>
        <div style={{ textAlign: 'center', margin: '0', marginTop: "24px", padding: (isMaintenance || isImpending) ? '30px' : undefined }}>
          <Title style={{padding:'10px', marginTop:'18px'}}level={2}>Applicant</Title>
        </div>
        <Divider />
        <Row>
          <Col xs={24} md={12} lg={8}>
            <Paragraph className={'alignRightMedium'}>
              <Paragraph>
                <Title level={4} style={{ paddingBottom: '15px',textAlign: 'center' }}>
                  Please click the button below to log in using your Credential Verification for Health Professionals username and password, or to create an account.
                </Title>
  
                <Paragraph style={{ textAlign: 'center' }}>
                  <Paragraph className={'loginForm'}>
                    <Paragraph style={{ textAlign: 'center' }}>
                    {/* <Button type="primary" onClick={handleLogin}>
                    Login or Create Account
                    </Button> */}
                    <Button size="large" style={{ margin: '3px' }} type="primary" disabled={isProcessing} htmlType="submit" onClick={handleLogin}>
                        {isProcessing ? (
                          <>
                            <Spin size="small" style={{ paddingRight: '20px' }} /> Processing...
                          </>
                        ) : (
                          <>Login or Create Account</>
                        )}
                      </Button>
                    </Paragraph>
                  </Paragraph>
                </Paragraph>
              </Paragraph>
            </Paragraph>
          </Col>
          <Col xs={0} md={1}>
            <Paragraph
              style={{
                paddingLeft: '50%',
                marginRight: '50%',
                minHeight: '100%',
                borderRight: '1px solid black'
              }}
            ></Paragraph>
          </Col>
          <Col xs={24} md={0}>
            <Paragraph style={{ paddingTop: '30px' }}></Paragraph>
          </Col>
          <Col xs={24} md={11} lg={15}>
            <Paragraph>
              This application is for individuals in certain health professions who have been required by the organizations to which they are applying to have professional qualification(s)/credential(s) primary-source verified by ECFMG®, a division of Intealth™.

            </Paragraph>

            <Paragraph>
              This application is not for use by physicians. If you are a physician who needs to have credentials verified, please visit the <Link href={"https://www.ecfmg.org"} target={'_blank'} rel="noreferrer" style={{color: "#3F4373"}}>ECFMG website</Link> for information.  
            </Paragraph>
            
            <Collapse ghost>
              <Panel
                header={
                  <Space>
                    <InfoCircleOutlined /> Important Information
                  </Space>
                }
                key="instructions"
              >
                <Paragraph
                  style={{
                    textAlign: 'initial',
                    fontSize: '14px',
                    color: 'rgba(0, 0, 0, 1)'
                  }}
                >
                  <Paragraph>
                    Before proceeding with this application, please ensure that you have read and understood any and all instructions that the organization to which you are applying has provided to you regarding the credential(s) that you need to have verified. 

                  </Paragraph>
                  <Paragraph>
                    Once you begin your application, the information you enter will be saved for approximately 24 hours. If you do not submit the application within that time, you will be required to re-enter the information.
                  </Paragraph>
                  <Paragraph>
                    Full payment is due when you submit your application. You must use a Visa, MasterCard, Discover, or American Express with a security code.
                  </Paragraph>
                  <Paragraph>Once your application has been submitted, you can use this website to check the status of your application.
                  </Paragraph>
                </Paragraph>
              </Panel>
            </Collapse>
          </Col>
        </Row>
      </>
    );
  
     /*   */
    return (
      <SubPageLayout fixedHeader={false} pageHeader={<LandingPageHeader />}>
      <Row justify={'center'}>
        <Col>{loginLayout}</Col>
      </Row>
    </SubPageLayout>
    );
  };
